


















































































import {
    customerContactData,
    SELECTED_PARTNER_UPDATE,
    SELECTED_PARTNER_DELETE,
    SPEAKING_PARTNER,
} from '@/store/modules/offersModule';
import offerMixins from '@/helpers/offers/offerMixin';

export default {
    mixins: [offerMixins],
    data(this:any) {
        return {
            speakingForm: { ...customerContactData },
            rules: {
                name: [
                    { required: true, message: this.$t('offer.pls_entr_name'), trigger: 'blur' },
                ],
                surname: [
                    { required: true, message: this.$t('offer.pls_entr_surname'), trigger: 'blur' },
                ],
            },
        };
    },

    methods: {
        closeDialog(this: any) {
            this.$emit('update:speaker', false);
        },

        updateSpeaker(this: any, formName: string) {
            this.$refs[formName].validate(async (valid: any) => {
                if (!valid) {
                    return false;
                }

                const updated = {
                    Code: this.speakingForm.id,
                    Typecode: this.speakingForm.department,
                    Appellative: this.speakingForm.gender,
                    Name: this.speakingForm.name,
                    Surname: this.speakingForm.surname,
                    Phonenumber: this.speakingForm.phone,
                    Email: this.speakingForm.email,
                    Language: this.speakingForm.language,
                };
                const payload = {
                    compCode: this.compCode,
                    speakingForm: updated,
                };
                try {
                    await this.$store.dispatch(SELECTED_PARTNER_UPDATE, payload);
                    await this.$store.dispatch(SPEAKING_PARTNER, this.compCode);
                    if (this.isSpeakerEdit) {
                        this.speakerMsg(this.$t('offer.update_success'), 2);
                    } else {
                        this.speakerMsg(this.$t('offer.add_success'), 2);
                    }
                } catch (e) {
                    this.speakerMsg(this.$t('offer.smthng_went_wrong'));
                }

                this.closeDialog();
                return true;
            });
        },

        speakerMsg(this:any, msg:string, val:number = 1) {
            let type = 'error';
            if (val === 2) type = 'success';
            this.$message({
                type,
                message: msg,
            });
        },

        async deleteSpeaker(this: any) {
            const contactinfo = {
                CompanyId: 21,
                Code: this.speakingForm.id,
                CompanyCode: this.compCode,
            };

            await this.$store.dispatch(SELECTED_PARTNER_DELETE, contactinfo);
            await this.$store.dispatch(SPEAKING_PARTNER, this.compCode);
            this.closeDialog();
        },
    },

    created(this: any) {
        if (this.isSpeakerEdit) {
            this.speakingForm = {
                ...this.$store.getters.getOffersData.customer.contact,
            };
        }
    },

    computed: {
        isSpeakerEdit(this: any) {
            return this.$store.getters.isSpeakerEdit;
        },

        options(this: any) {
            return this.$store.getters.repartoData;
        },
    },
};
